module.exports = __webpack_public_path__ + "static/media/care-icon.7bacc68c.png";